import { getPreviewMode } from '../../state/utils/contentful';

/**
 * Load screenEventsCollection and its children's id
 * @returns {DocumentNode}
 */
const queryFranchisingCollection = () => (
    `{
      screenFranchiseCollection(${getPreviewMode()}, where: {slug: "franchise"}) {
        items {
          title
          marketingComponentsCollection {
            items {
              ... on MarketingSection {
                sys {
                  id
                }
              }
            }
          }
        }
      }
    }
    `
);

/**
 * Load events
 * @param screenEventId
 * @returns {DocumentNode}
 */
const queryEvents = (screenEventId) => (
    `{
      screenEvents(${getPreviewMode()}, id: "${screenEventId}") {
        eventsCollection {
          items {
            title
            subtitle
            description {
              json
            }
            image {
              desktopMedia {
                url
              }
            }
            actionsCollection {
              items {
                linkToUrl
                title
              }
            }
          }
        }
      }
    }
    `
);

const queryMarketingSection = (marketingSectionId) => (
    `{
      marketingSection(${getPreviewMode()}, id:"${marketingSectionId}") {
        marketingComponentsCollection {
          items {
            ... on MarketingCard {
              image {
                desktopMedia {
                  url
                }
                mobileMedia {
                  url
                }
              }
            }
          }
        }
      }
    }
    `
);

export {
    queryFranchisingCollection,
    queryEvents,
    queryMarketingSection,
};
